import { Play } from 'lucide-react';

export function ContextFilterBar({ contextFilter, setContextFilter, contextTags, decisions, filteredDecisions, onStartBatchFlow }) {
  return (
    <div className="px-3 py-1.5 flex items-center gap-1 overflow-x-auto no-scrollbar" style={{ background: 'var(--pd-panel)', borderBottom: '1px solid var(--pd-border)' }}>
      {contextTags.map(ctx => {
        const count = ctx.key
          ? decisions.filter(d => d.context === ctx.key && d.category !== 'COMPLETED').length
          : decisions.filter(d => d.category !== 'COMPLETED').length;
        return (
          <button key={ctx.key} data-testid={`context-filter-${ctx.key || 'all'}`}
            onClick={() => setContextFilter(ctx.key)}
            className="flex items-center gap-1 px-2 py-1 rounded-lg text-[9px] font-semibold whitespace-nowrap transition-colors"
            style={{
              background: contextFilter === ctx.key ? ctx.color : 'var(--pd-panel-2)',
              color: contextFilter === ctx.key ? (ctx.activeText || 'white') : 'var(--pd-subtle)',
              border: `1px solid ${contextFilter === ctx.key ? ctx.color : 'var(--pd-border)'}`,
            }}
          >
            {ctx.label}
            {count > 0 ? <span className="tabular-nums">{count}</span> : null}
          </button>
        );
      })}
      {contextFilter && filteredDecisions.filter(d => d.category !== 'COMPLETED').length > 0 ? (
        <button data-testid="batch-focus-flow" onClick={onStartBatchFlow}
          className="ml-auto flex items-center gap-1 px-2 py-1 rounded-lg text-[9px] font-semibold" style={{ background: 'var(--pd-focus)', color: 'white' }}>
          <Play className="w-3 h-3" />Focus flow
        </button>
      ) : null}
    </div>
  );
}

export function BatchFlowPanel({ batchFlow, onComplete, onSkip, onDefer, onExit }) {
  if (!batchFlow) return null;
  const current = batchFlow.items[batchFlow.current];
  if (!current) return null;

  return (
    <div data-testid="batch-flow-panel" className="px-5 py-4" style={{ background: 'var(--pd-panel)', borderBottom: '1px solid var(--pd-border)' }}>
      <div className="flex items-center justify-between mb-2">
        <div className="text-[10px] uppercase tracking-[0.08em] font-semibold" style={{ color: 'var(--pd-subtle)' }}>
          Focus flow · {batchFlow.current + 1}/{batchFlow.items.length}
        </div>
        <button data-testid="batch-flow-exit" onClick={onExit} className="text-[10px] font-semibold" style={{ color: 'var(--pd-muted)' }}>Exit flow</button>
      </div>
      <div className="rounded-2xl p-4" style={{ background: 'var(--pd-panel-2)', border: '1px solid var(--pd-border)' }}>
        <div className="text-[15px] font-semibold mb-1" style={{ color: 'var(--pd-text)', letterSpacing: '-0.02em' }}>{current.title}</div>
        <div className="text-[11px] mb-3" style={{ color: 'var(--pd-muted)' }}>
          {current.estimatedMinutes || 0}min · {current.priority || 'MEDIUM'}
        </div>
        <div className="flex gap-2">
          <button data-testid="batch-flow-done" onClick={() => onComplete(current)}
            className="px-3 py-2 rounded-xl text-[11px] font-semibold text-white" style={{ background: 'var(--pd-green)' }}>Done</button>
          <button data-testid="batch-flow-skip" onClick={onSkip}
            className="px-3 py-2 rounded-xl text-[11px] font-semibold" style={{ background: 'var(--pd-panel)', color: 'var(--pd-muted)', border: '1px solid var(--pd-border)' }}>Skip</button>
          <button data-testid="batch-flow-defer" onClick={() => onDefer(current)}
            className="px-3 py-2 rounded-xl text-[11px] font-semibold" style={{ background: 'var(--pd-panel)', color: 'var(--pd-warning)', border: '1px solid var(--pd-border)' }}>Defer</button>
        </div>
      </div>
      <div className="mt-3 h-1 rounded-full" style={{ background: 'var(--pd-border)' }}>
        <div className="h-full rounded-full transition-all" style={{ width: `${((batchFlow.current) / batchFlow.items.length) * 100}%`, background: 'var(--pd-focus)' }} />
      </div>
    </div>
  );
}
